import { faker } from '@faker-js/faker';
import { IClaimMessengerSyncStatus } from 'app/claims/components/messenger/interfaces/claim-messenger-sync-status.interface';

export function makeSyncStatus(overrides: Partial<IClaimMessengerSyncStatus> = {}): IClaimMessengerSyncStatus {
    const lastAttemptedSyncAt = faker.date.recent({ days: 7 });
    const syncFailed = overrides.syncFailed ?? faker.datatype.boolean(0.2);
    const lastSyncedAt = overrides.lastSyncedAt
        ? new Date(overrides.lastSyncedAt)
        : syncFailed
            ? faker.date.between({ from: '2025-01-01', to: lastAttemptedSyncAt })
            : faker.date.between({ from: lastAttemptedSyncAt, to: new Date() });

    return {
        lastAttemptedSyncAt,
        lastSyncedAt,
        syncFailed,
        ...overrides,
    };
}
